import { render, staticRenderFns } from "./MitManageReportsLowInventoryPage.vue?vue&type=template&id=027b0750&scoped=true"
import script from "./MitManageReportsLowInventoryPage.vue?vue&type=script&lang=js"
export * from "./MitManageReportsLowInventoryPage.vue?vue&type=script&lang=js"
import style0 from "./MitManageReportsLowInventoryPage.vue?vue&type=style&index=0&id=027b0750&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "027b0750",
  null
  
)

export default component.exports